import includes from "lodash/includes";
import styled from "styled-components";
export const SIZES = {
    CLOSE_FONT: 14,
    CLOSE_ICON_SIZE: 20,
    CLOSE_BTN_SIZE: 14,
    CLOSE_BTN_OFFSET_RIGHT: -45,
    CLOSE_BTN_OFFSET_TOP: -20,
    CLOSE_BTN_PADDING: 10
};
export default {
    Container: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes(["rowsCount"], prop)
    }) `
    margin: -${({ theme }) => theme["panel-body-padding"]};
    display: grid;
    grid-template-rows: ${({ rowsCount }) => (rowsCount === 1 ? "1fr" : "1fr auto")};
    height: calc(100% + ${({ theme }) => 2 * parseInt(theme["panel-body-padding"])}px);
    > :last-child {
      align-self: end;
    }
    > :first-child {
      align-self: start;
    }
  `
};
